import React, { useEffect, useState } from 'react'
import Logo from '../tools/Logo'
import { useGetRequestedMaterialsQuery, useUpdateRequestedMaterialMutation } from '../../store/api/RequestedMaterialsApi';
import PDFGenerator from '../tools/PDFGenerator';
import { useCreateMovementMutation, useCreateProductOrderMutation } from '../../store/api/movementApi';
import { useGetConsumerQuery } from '../../store/api/consumerApi';
import { useGetProductsQuery } from '../../store/api/productsApi';
import Swal from 'sweetalert2';

const orderData = {
    Id: 0,
    consumerId: null,
    supplierId: null,
    OrderType: "Consumed",
    UsersId: null,
};
const RequestedMaterials = () => {
    const [materials, setMaterials] = useState([])
    const [filteredData, setFilteredData] = useState([]);
    const [UpdateRequestedMaterial] = useUpdateRequestedMaterialMutation()
    const [createProductOrders] = useCreateProductOrderMutation();
    const [createMovement] = useCreateMovementMutation();
    const [consumers, setConsumers] = useState([]);
    const [orderConsumer, setOrderConsumer] = useState(orderData);
    const [productsList, setProductsList] = useState([])

    const [open, setOpen] = useState(false);

    const [openIndex, setOpenIndex] = useState(0);

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(6);
    const { data, error, isLoading } = useGetRequestedMaterialsQuery({
        refetchOnMountOrArgChange: false
    })
    const { data: productList, refetch: refetchProductList } = useGetProductsQuery()


    const { data: consumer } = useGetConsumerQuery({
        refetchOnMountOrArgChange: true,
    });


    useEffect(() => {
        if (consumer) {
            setConsumers(consumer);
        }
    }, [consumer]);




    useEffect(() => {
        if (data && Array.isArray(data)) {
            setMaterials(data);
        }
    }, [data]);


    useEffect(() => {
        const filterData = () => {
            let filtered = materials;

            filtered = filtered.filter(item => item[0]?.isAproved === 'Unapproved'  && item[0]?.isRejected === "Not Rejected");

            setFilteredData(filtered);
        };
        filterData();
    }, [materials]);




    useEffect(() => {
        if (productList && Array.isArray(productList)) {
            setProductsList(productList)
        }
    }, [productList]);



    if (isLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
                <div className="color-text fs-4">Loading...</div>
            </div>
        )
    }

    if (error) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
                <div className="row">
                    <div className="col-12 opacity-75 bg-light p-4 rounded-3 shadow-md border">
                        <h3 className="text-danger">Opps!!!</h3>
                        <span className="fs-4">
                            <span className="text-danger"> An Error has occurred</span>
                        </span>
                        <div className="fs-5"> The server is shut down 😢</div>
                    </div>
                </div>
            </div>
        )
    }


    const showData = (index) => {
        setOpenIndex(index);
        setOpen(!open);
    };

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };


    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    const showPrevious = currentPage > 1;
    const showNext = currentPage < totalPages;

    const handleItemsPerPageChange = (e) => {
        const newItemsPerPage = parseInt(e.target.value);
        setItemsPerPage(newItemsPerPage);

        setCurrentPage(1);


        if (currentPage > totalPages) {
            setCurrentPage(totalPages);
        }
    };





    
    


    const createProductOrder = async () => {
        const userData = JSON.parse(localStorage.getItem("UserData"));
        const userId = userData ? userData.id : null;
        const orderData = {
            ...orderConsumer,
            GenId: filteredData[openIndex][0]?.genId,
            UsersId: userId,
        };

        const savedOrderData = await createProductOrders(orderData);

        return savedOrderData;
    };






    const handlCreateMaterialIssue = async (e, index) => {
        e.preventDefault();

        const productOrderResponse = await createProductOrder();

        if (productOrderResponse.data.status === 200) {
            for (let i = 0; i < filteredData[openIndex].length; i++) {
                const item = filteredData[openIndex][i];
                const movementResponse = await createMovement({
                    ProductsId: item.productsId,
                    OrderQty: item.recievedQty,
                    OrderPurpose: item.description, 
                    OrderType: "Consumed", 
                    GenId: item.genId,
                    ProductOrderId: productOrderResponse.data.orders?.id,
                });

                if (movementResponse.data.status !== 200) {
                    
                    break;
                }

            }
        }

        await refetchProductList();
    };


















    const handleModifyMaterialRequest = async (e, index) => {
       await handlCreateMaterialIssue(e)
        const selectedConsumer = consumers.find(
            (c) => c.id === parseInt(orderConsumer.consumerId)
        );
        console.log(orderConsumer);

        PDFGenerator(filteredData[index], filteredData[index][0].genId, filteredData[index][0].taskGenId, selectedConsumer?.name);
        for (const item of filteredData[index]) {
            UpdateRequestedMaterial({
                Id: item.id,
                Name: item.name,
                ProductsId: item.productsId,
                RequestedQty: item.requestedQty,
                Description: item.description,
                GenId: item.genId,
                RecievedQty: item.recievedQty,
                isRecieved: parseInt(item.recievedQty) > 0 ? true : false,
                isAproved: parseInt(item.recievedQty) > 0 ? true : false,
                isRejected: parseInt(item.recievedQty) > 0 ? false : true,
            })
        }
    };




    const handleModifyRecivedQty = (e, dataIndex) => {
        // Create a copy of filteredData
        const updatedData = filteredData.map((list, index) => {
            // Only update the list at openIndex
            if (index === openIndex) {
                return list.map((item, idx) => {
                    // Only update the specific item at dataIndex
                    if (idx === dataIndex) {
                        var Qty = productsList.find(product => product.id === item.productsId)?.qty;
                        if (parseInt(e.target.value) > item.requestedQty) {
                            Swal.fire({
                                title: 'Invalid Quantity!',
                                text: "You Entered Incorrect Quantity",
                                icon: 'error',
                                confirmButtonText: 'Close'
                            })
                        } else if (parseInt(e.target.value) > Qty) {
                            Swal.fire({
                                title: 'Insufficient Quantity!',
                                text: "You entered more than the total quantity in stock",
                                icon: 'error',
                                confirmButtonText: 'Close'
                            })
                        }
                        return { ...item, recievedQty: parseInt(e.target.value) > item.requestedQty ? 0 : parseInt(e.target.value) > Qty ? 0 : e.target.value };
                        // return { ...item, recievedQty: parseInt(e.target.value) > item.requestedQty ? 0 : e.target.value };
                    }
                    return item; // Return unchanged items
                });
            }
            return list; // Return unchanged lists
        });
        setFilteredData(updatedData);
    };





    return (
        <>
            <div className='block-content-full p-3'>
                <div className="block-header block-header-default px-5">
                    <h3 className="block-title"> <Logo _width={30} name={'/icons/paper.svg'} _height={30} _marginLeft={-20} /> <small className='mx-2'>Requested Materials</small></h3>
                </div>
                <div className="block">
                    <div className="block-content block-content-full">
                      
                      {
                        currentItems && currentItems.length > 0 && ( <div className="row">
                            <div className="col-sm-12 hover">
                                <div className="mb-3">
                                    <div className="row">
                                        <label
                                            htmlFor="selectSupplier"
                                            className="form-label text-start"
                                        >
                                            Select Consumer
                                        </label>
                                    </div>
                                    <select
                                        name='ProductsId'
                                        className="form-select"
                                        style={{ height: '45px' }}
                                        aria-label="Default select example"
                                        id="selectSupplier"
                                        onChange={(e) => setOrderConsumer({ ...orderConsumer, consumerId: e.target.value })}

                                        value={
                                            orderConsumer.consumerId === 0
                                                ? "Select Consumer"
                                                : orderConsumer.consumerId
                                        }
                                    >
                                        <option selected>Select Consumer</option>

                                        {consumers?.map((consumer) => (
                                            <option key={consumer.id} value={consumer.id}>
                                                {consumer.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>)
                      }  
                     

                        <div>
                            {
                                currentItems.map((list, index) => {
      
                                    
                                    return  <div className="card mt-3">
                                    <div className="card-header d-flex justify-content-between align-items-center">
                                        <div className='d-flex justify-content-between'>
                                            <button
                                                className="btn btn-link bg-"
                                                onClick={(e) => showData(index)}
                                                aria-controls="example-collapse-text"
                                                aria-expanded={open}
                                            >
                                                {open && index === openIndex ? <span>&#9660;</span> : <span>&#9650;</span>}
                                            </button>
                                            <h6 className='mt-3'>{list[0]?.genId}</h6>
                                        </div>
                                        <h6 className='mt-3'>{list && list.length > 0 && [...new Set(list.map(req => req.created))]}</h6>
                                    </div>
                                    {open && index === openIndex && (
                                        <div id="example-collapse-text" className="collapse show">
                                            <div className="card-body">

                                                <div className="table-responsive position-relative" style={{ overflowX: 'auto' }}>
                                                    <table class="table mb-5 " style={{ minWidth: '800px' }}>
                                                        <thead className='table-secondary'>
                                                            <tr>
                                                                <th scope="col">#</th>
                                                                <th scope="col">Name</th>
                                                                <th scope="col">Requested Qty</th>
                                                                <th scope="col">Unit</th>
                                                                <th scope="col">Total Qty In Stock</th>
                                                                <th scope="col">Recieved Qty</th>
                                                                <th scope="col">Approved</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                list.map((data, dataIndex) => {
                                                                    return <>
                                                                        <tr>
                                                                            <th>{dataIndex + 1}</th>
                                                                            <td>{data.name}</td>
                                                                            <td>{data.requestedQty}</td>
                                                                            <td>{data.uniteName}</td>
                                                                            <td>{productsList.find(product => product.id === data.productsId)?.qty - data.recievedQty}</td>
                                                                            <td>
                                                                                <input
                                                                                    type="number"
                                                                                    value={data.recievedQty}
                                                                                    onChange={(e) => handleModifyRecivedQty(e, dataIndex)}
                                                                                    className="form-control w-25  InputNumber"
                                                                                    min={0}

                                                                                />
                                                                            </td>
                                                                            <td>
                                                                                {data.recievedQty > 0 ? <span className={'btn btn-sm bg-success text-white rounded-5 pe-3 px-3'}>Approved</span> : <span className={'p-1 bg-danger text-white rounded-5 pe-3 px-3'}>Unapproved</span>}
                                                                            </td>

                                                                            {/* <button onClick={(e) => handleModifyMaterialRequest(e, openIndex)} className={'btn btn-sm bg-primary text-white rounded-2 pe-3 px-3 mt-5  position-absolute bottom-0 end-0'}>Sumbit</button> */}



                                                                        </tr>

                                                                    </>

                                                                })
                                                            }
                                                        </tbody>
                                                    </table>

                                                </div>
                                                <div className='card-footer text-end'>
                                                    <button
                                                        disabled={orderConsumer.consumerId === null || orderConsumer.consumerId === ""}
                                                        onClick={(e) => handleModifyMaterialRequest(e, openIndex)}
                                                        className="btn btn-sm bg-primary text-white rounded-2 pe-3 px-3"

                                                    >
                                                        Submit
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                })
                            }
                        </div>

                        {
                            currentItems.length > 0 && (
                                <div className='mt-4'>

                                    <ul className="pagination justify-content-end">
                                        <li className={`page-item ${showPrevious ? '' : 'disabled'}`}>
                                            <button className="page-link" onClick={() => handlePageChange(currentPage - 1)} disabled={!showPrevious}>
                                                Previous
                                            </button>
                                        </li>
                                        <li className="page-item disabled">
                                            <span className="page-link">{currentPage}</span>
                                        </li>
                                        <li className={`page-item ${showNext ? '' : 'disabled'}`}>
                                            <button className="page-link" onClick={() => handlePageChange(currentPage + 1)} disabled={!showNext}>
                                                Next
                                            </button>
                                        </li>
                                        <li className="page-item mx-2">
                                            <select className="form-select p-0 px-5 py-1 rounded-0" value={itemsPerPage} onChange={handleItemsPerPageChange}>
                                                <option value="1">1</option>
                                                <option value="3">3</option>
                                                <option value="6">6</option>
                                                <option value="10">10</option>
                                                <option value="20">20</option>
                                                <option value="30">30</option>
                                            </select>
                                        </li>
                                    </ul>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default RequestedMaterials